import React, { useState } from "react";
import {
  Navbar,
  Container,
  Image,
  Nav,
  Row,
  Col,
  Button,
  Table,
} from "react-bootstrap";
// import "../Layout/NewHeader/NewUI.css";
import { Link, useLocation } from "react-router-dom";

const DashBoardBotCard = (props) => {
  return (
    <>
      <div className="new-dashboard-bot-sec">
        <Row>
          <Col md={6}>
            <div className="new-dashboard-bot-card">
              <div className="new-dashboard-bot-header-sec">
                <div className="new-dashboard-bot-header-left-sec">
                  <h3>Bots</h3>
                  <Link to="#" className="view-all-link">
                    View All
                  </Link>
                </div>
                <div className="new-dashboard-bot-header-right-sec">
                  <div className="onboarding-fine-tunings-files-header-sec">
                    <Button className="onboarding-add-fine-tuning-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        fill="#fff"
                        x="0"
                        y="0"
                        enableBackground="new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        xmlSpace="preserve"
                      >
                        <path d="M480 224H288V32c0-17.673-14.327-32-32-32s-32 14.327-32 32v192H32c-17.673 0-32 14.327-32 32s14.327 32 32 32h192v192c0 17.673 14.327 32 32 32s32-14.327 32-32V288h192c17.673 0 32-14.327 32-32s-14.327-32-32-32z"></path>
                      </svg>
                      <span>Add Bot</span>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="new-dashboard-bot-body-sec">
                <div className="new-dashboard-bot-table-sec">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>SI.No</th>
                        <th>Bots</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Bots name 1</td>
                        <td>
                          <Link to="#" className="view-link-btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              fill="#03363d"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 000 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 000-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.918 2.918 0 010-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811a2.918 2.918 0 010 3.068z"></path>
                              <path d="M12 7a5 5 0 105 5 5.006 5.006 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"></path>
                            </svg>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Bots name 3</td>
                        <td>
                          <Link to="#" className="view-link-btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              fill="#03363d"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 000 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 000-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.918 2.918 0 010-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811a2.918 2.918 0 010 3.068z"></path>
                              <path d="M12 7a5 5 0 105 5 5.006 5.006 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"></path>
                            </svg>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Bots name 4</td>
                        <td>
                          <Link to="#" className="view-link-btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              fill="#03363d"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 000 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 000-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.918 2.918 0 010-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811a2.918 2.918 0 010 3.068z"></path>
                              <path d="M12 7a5 5 0 105 5 5.006 5.006 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"></path>
                            </svg>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Bots name 5</td>
                        <td>
                          <Link to="#" className="view-link-btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              fill="#03363d"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 000 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 000-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.918 2.918 0 010-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811a2.918 2.918 0 010 3.068z"></path>
                              <path d="M12 7a5 5 0 105 5 5.006 5.006 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"></path>
                            </svg>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DashBoardBotCard;
